import { Action } from 'redux';

export const BASKET_TOGGLE = 'BASKET_TOGGLE';
export const BASKET_CLOSE = 'BASKET_CLOSE';
export const BASKET_OPEN = 'BASKET_OPEN';
export const SHOW_PRODUCT_ADDED = 'SHOW_PRODUCT_ADDED';
export const HIDE_PRODUCT_ADDED = 'HIDE_PRODUCT_ADDED';

export const basketToggle = (): Action => ({
  type: BASKET_TOGGLE
});

export const basketClose = (): Action => ({
  type: BASKET_CLOSE
});

export const basketOpen = (): Action => ({
  type: BASKET_OPEN
});

export const showProductAdded = (): Action => ({
  type: SHOW_PRODUCT_ADDED
});

export const hideProductAdded = (): Action => ({
  type: HIDE_PRODUCT_ADDED
});
